<mat-spinner color="secondary" *ngIf="showSpinnerIfNecessary && (!project && !errorLoadingProject || ssrProjectLoad)" />

<div *ngIf="!ssrProjectLoad && errorLoadingProject" class="error-loading-project">
  <h3>Error Loading</h3>
  <p>
    There was an error loading your order item.
    Please refresh the page to try again.
  </p>
</div>

<ng-container *ngIf="!errorLoadingProject && !ssrProjectLoad && project">

  <div class="fx-layout-row fx-layout-column--xs fx-align--center-x
              fx-gap--4px fx-gap--0px--xs">
    <div class="left-col fx-flex" *ngIf="builderType !== 'SAMPLE'">
      <!--
      <div class="builder-upsell" style="text-align: center">
        <span>
          ★
          We have <a (click)="customCornerInfo()">custom corner</a> &amp; <a (click)="vGrooveInfo()">v-groove</a>
          options!
          ★
        </span>
      </div>
      -->
      <div class="heading">
        <h1 *ngIf="builderType === 'SAMPLE'">Product Samples</h1>
        <h1 *ngIf="project.builderHeading" [innerHTML]="project.builderHeading"> </h1>
        <h2 *ngIf="project.builderSubHeading" [innerHTML]="project.builderSubHeading"> </h2>
      </div>

      <mbnm-carousel class="builder-preview-carousel" [ngClass]="{visible: project?.canPreview}" *ngIf="project"
                     #mobileCarouselComponent>
        <mat-tab-group mbnmAddClass="carousel-selector" mbnmAddClassSelector="mat-tab-header" disableRipple="true"
                       [ngClass]="{'hide-tabs': !project.moulding && !project.backingBoard && !project.glazing && !project.bag}"
                       [(selectedIndex)]="selectedCarouselTab">
          <mat-tab>
            <ng-template mat-tab-label>
              <img alt="Custom Matboard Preview" *ngIf="projectThumbs && project && (project.moulding || project.backingBoard || project.glazing || project.bag)" [src]="projectThumbs.preview">
            </ng-template>
            <mbnm-project-preview #preview [project]="project" (editRequested)="projectEditRequested($event)">
            </mbnm-project-preview>
          </mat-tab>
          @if (project.moulding) {
            @for (view of ['profile','corner','front','back','hanger','spec']; track view) {
              <mat-tab>
                <ng-template mat-tab-label>
                  <img *ngIf="view !== 'hanger'"
                       [alt]="'moulding ' + view + ' preview'"
                       [src]="'/assets/images/products/frames/' + project.moulding.code + '/' + view + '-thumb.jpg'" />
                  <img *ngIf="view === 'hanger'"
                       [alt]="project.frameHangerType + 'hanger'"
                       [src]="'/assets/images/products/hangers/' + project.frameHangerType + '-thumb.jpg'" />
                </ng-template>

                <mbnm-basic-merch *ngIf="view !== 'hanger'" [title]="project.moulding.description + ' - ' + viewDescriptions[view]" [imageUrl]="'/assets/images/products/frames/' + project.moulding.code + '/' + view + '-screen.jpg'"></mbnm-basic-merch>
                <mbnm-basic-merch *ngIf="view === 'hanger'" title="Frame Hanger Type" [imageUrl]="'/assets/images/products/hangers/' + project.frameHangerType + '-screen.jpg'"></mbnm-basic-merch>
              </mat-tab>
            }
          }

          <mat-tab *ngIf="project.backingBoard">
            <ng-template mat-tab-label>
              <img alt="Backing board" *ngIf="projectThumbs && projectThumbs.backing" [src]="projectThumbs.backing">
            </ng-template>
            <mbnm-basic-merch [project]="project" projectPropertyName="backingBoard"></mbnm-basic-merch>
          </mat-tab>
          <mat-tab *ngIf="project.glazing">
            <ng-template mat-tab-label>
              <img alt="Plexiglass glazing" *ngIf="projectThumbs && projectThumbs.glazing" [src]="projectThumbs.glazing">
            </ng-template>
            <mbnm-basic-merch [project]="project" projectPropertyName="glazing"></mbnm-basic-merch>
          </mat-tab>
          <mat-tab *ngIf="project.bag">
            <ng-template mat-tab-label>
              <img alt="Show bags" *ngIf="projectThumbs && projectThumbs.bag" [src]="projectThumbs.bag">
            </ng-template>
            <mbnm-basic-merch [project]="project" projectPropertyName="bag"></mbnm-basic-merch>
          </mat-tab>
        </mat-tab-group>
      </mbnm-carousel>
    </div>

    <div class="right-col"
        [ngClass]="{'is-sample': builderType == 'SAMPLE'}">

      <mbnm-price-and-buy class="fx-layout-row fx-align--space-between-x fx-align--x-center fx-gap--16px"
                          [project]="project"
                          (cancelEditClicked)="cancelEdit()"
                          (addToCartClicked)="addToCartClicked($event)">
      </mbnm-price-and-buy>
         <!--
        [ngStyle.xs]="{'padding-bottom': project?.canBuy ? '111px' : '10px'}">
        -->
      <!-- TILES -->
      @for (productCategory of tileData; track productCategory; let idx = $index) {
        <div class="fx-layout-row fx-align--space-between-x fx-align--x-center" *ngIf="productCategory.mainHeading">
          <div>
            <h3 class="group-title" *ngIf="productCategory.mainHeading">
              {{ productCategory.mainHeading }}
            </h3>
            <div class="sub-heading" *ngIf="productCategory.subHeading" [innerHtml]="productCategory.subHeading">
            </div>
          </div>
          <div>
            <button class="clear-all" color="secondary" mat-flat-button="" *ngIf="idx == 0 && !project?.design" (click)="clearAll($event)">
              Clear All
            </button>
          </div>
        </div>


        <mbnm-builder-tile #tile *ngIf="productCategory?.title" (click)="openSelectorDialog(productCategory)"
                           [title]="productCategory?.title" [ngClass]="{'can-buy': project?.canBuy}"
                           [leftAlign]="true" [helpInfo]="productCategory.helpInfo"
                           [disabled]="(productCategory.filteredProducts && productCategory.filteredProducts.length == 0) || missingDependencies(productCategory) >= 0"
                           [openIcon]="determineTileIcon(productCategory)">

          <!-- REGULAR PRODUCT DESCRIPTION -->
          <div class="description" *ngIf="productCategory.selection.length > 0 && project.numSamples == 0"
               [hidden]="tile.selected">

            <a class="remove" [hidden]="project.permanentDesignId && productCategory.type === 'MAT'" (click)="removeProductSelection($event, productCategory);"><mat-icon svgIcon="x"></mat-icon></a>

            <span *ngIf="productCategory.selection[0]">
              {{ productCategory.type == 'FRAME' ? productCategory.selection[0].longDescription : productCategory.selection[0].description }}
              <ng-container *ngIf="productCategory.type == 'FRAME' && project.frameHangerType === 'wire'">
                /w Wire Hanging Kit
              </ng-container>
              <ng-container *ngIf="productCategory.type == 'FRAME' && project.frameHangerType === 'sawtooth'">
                /w Sawtooth Hanger
              </ng-container>
              <ng-container *ngIf="productCategory.type == 'SHOWBAG'">
                {{ productCategory.selection[0].longDescription }}
              </ng-container>
              <ng-container *ngIf="productCategory.type == 'MAT'">
                (#{{productCategory.selection[0].code}})
                <ng-container *ngIf="productCategory.projectProperty == 'bottomMat'">
                  with {{ project.reveal | size:'multichar' | inches }} Reveal
                </ng-container>
              </ng-container>
            </span>
          </div>

          <div class="description" style="display: block" *ngIf="productCategory.type == 'MAT' && productCategory.projectProperty == 'topMat' && project.vGrooveOffset > 0">
            <a class="remove" [hidden]="project.permanentDesignId && productCategory.type === 'MAT'" (click)="removeVGroove($event);">
              <mat-icon svgIcon="x"></mat-icon>
            </a>
            <span>
              {{ project.vGrooveOffset | size:'multichar' | inches }} Offset V-Groove
            </span>
          </div>

          <!-- REGULAR PRODUCT DESCRIPTION UPSELL -->
          <div class="description upsell" *ngIf="productCategory.selection.length == 0">
            <span *ngIf="this.determineCategoryState(productCategory) === 'required' && productCategory.isRequiredText !== null">
              {{ productCategory.isRequiredText }}
            </span>
            <span *ngIf="this.determineCategoryState(productCategory) !== 'required'  && productCategory.upsellText !== null">
              {{ productCategory.upsellText }}
            </span>
          </div>

          <!-- SIZES DESCRIPTION -->
          <div class="description bg" *ngIf="productCategory.type == 'SIZE-SELECTOR' && !project.size.incomplete">
              <span>
                <i>{{ project.size.toString() }}</i> Outer Size
                <ng-container *ngIf="!project.design || project.numOpenings > 0">
                  @for (opening of project.openings; track opening.size; let idx = $index) {
                    <div *ngIf="!opening.size.incomplete">
                      <i>{{ opening.size.toString() }}</i>
                      <i *ngIf="opening.shape && opening.shape[0]"> {{ opening.shape[0].description }}</i> Opening
                      <i *ngIf="opening.left && opening.top">
                        at ({{ opening.left | size | inches }},{{ opening.top | size | inches }})
                      </i>
                      <span *ngIf="opening.reveal && opening.reveal > 0">
                        with {{ opening.reveal | size | inches }} reveal
                      </span>
                    </div>
                  }
                </ng-container>
                <div *ngIf="project.design && project.numOpenings === 0">
                  <br />
                  Custom Opening(s)
                </div>
                <ng-container *ngIf="project.numMats > 1 && !project.permanentDesignId">
                  <br />
                  <i>{{ project.reveal | size:'multichar' | inches }}</i> Reveal
                </ng-container>
                <ng-container *ngIf="project.centeredMargins.height !== project.bottomMargin && project.numOpenings > 0 && !project.opening.size.incomplete">
                  <br />
                  <i>{{ project.bottomMargin | size:'multichar' | inches }}</i> Bottom Margin
                  <i *ngIf="project.bottomMargin == project.topCenterBottomMargin">
                    (Top Centered)
                  </i>
                </ng-container>

                <!-- Include details of the design v-groove -->
                @for (vgroove of project.vgrooves; track vgroove.size) {
                  <br />
                  <i>{{ vgroove.size.width | size | inches }} x {{ vgroove.size.height | size | inches }}</i>
                  <i *ngIf="vgroove.shape && vgroove.shape[0]"> {{ vgroove.shape[0].description }}</i> V-Groove
                  <i *ngIf="vgroove.left && vgroove.top">
                    at ({{ vgroove.left | size | inches }},{{ vgroove.top | size | inches }})
                  </i>
                }
              </span>
          </div>

          <!-- NOT AVAILABLE -->
          <div class="description" *ngIf="(productCategory.selection.length == 0 && productCategory.filteredProducts) || missingDependencies(productCategory) >= 0">
            <span *ngIf="productCategory.filteredProducts && productCategory.filteredProducts.length == 0">None Available</span>
            <span *ngIf="missingDependencies(productCategory) >= 0" [innerHtml]="productCategory.missingDependencyMessage[missingDependencies(productCategory)]"></span>
          </div>

          <!-- SAMPLES DESCRIPTION -->
          @for (sample of getProjectSamples(productCategory.type); track sample) {
          <div class="description samples">
            <a class="remove" (click)="removeSample($event, sample);"><mat-icon svgIcon="x"></mat-icon></a>
            <span>
              {{ productCategory.type == 'FRAME' ? sample.longDescription : sample.description }}
              <ng-container *ngIf="productCategory.type == 'SHOWBAG'">
                {{ sample.longDescription }}
              </ng-container>
              <ng-container *ngIf="productCategory.type == 'MAT'">
                (#{{sample.code}})
              </ng-container>
            </span><br />
          </div>
          }
        </mbnm-builder-tile>
      }

      <ng-container *ngIf="project && builderType !== 'SAMPLE'">
        <h3 class="group-title">
          Artwork <i>(Preview Only)</i>
        </h3>
        <div class="artwork">
          <div class="description">
            <span *ngIf="project?.hasPrint">
              The artwork presented is for preview purposes only.
              <strong>No print will be provided.</strong>
              Click <a (click)="removePrint()">here to remove</a> your artwork.
            </span>
            <span *ngIf="!project?.hasPrint">
              Upload an image of your artwork to help visualize the final product.  This step is optional. <strong>No print will be provided.</strong>
            </span>
            <mbnm-uploader [disclaimerAccepted]="project.hasPrint" acceptedFileTypes="image/*"
                           (uploadComplete)="printUploadCompleted($event)"
                           uploadPath="/print/"
                           (uploadFailed)="printUploadFailed($event)">
              <mat-icon svgIcon="image-upload"></mat-icon>
            </mbnm-uploader>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="(builderType === 'MAT' || builderType === 'FRAME') && project?.allowCustomization">
        <h3 class="group-title line-above" *ngIf="project?.allowCustomization">
          Upload Design File
        </h3>
        <div class="artwork">
          <div class="description">
            <span>
              Upload design (GMC/WZX) files.  Uploading more than once will replace
              previously uploaded files.
            </span>
            <mbnm-uploader [disclaimerAccepted]="true" acceptedFileTypes=".gmc,.wzx,.wcx" [allowMultiple]="true"
                           uploadPath="/design/"
                           (uploadComplete)="designUploaded($event)"
                           (uploadFailed)="designUploadFailed($event)">
              <mat-icon svgIcon="upload"></mat-icon>
            </mbnm-uploader>
          </div>
        </div>
        <div class="design-upload-notifications">
          <mat-form-field>
            <mat-label>complexity upcharge</mat-label>
            <input matInput
                   type="number"
                   [(ngModel)]="project.complexityUpCharge">
          </mat-form-field>
          <br />
          <mat-form-field>
            <mat-label>special instructions</mat-label>
            <textarea matInput rows="5"
                [(ngModel)]="project.instructions">
            </textarea>
          </mat-form-field>
        </div>
      </ng-container>

      <div *ngIf="project && this.builderType !== 'SAMPLE'"
           class="share-container fx-layout-row fx-layout-wrap fx-gap--8px fx-align--space-between-x">
        @for (shareType of shareTypes; track shareType) {
        <div class="fx-layout-column fx-flex--100--lt-md"
             [ngClass]="{'fx-flex--100': shareType.name === 'help', 'fx-flex--45--gt-sm': shareType.name !== 'help'}">
          <button mat-flat-button (click)="startShare(shareType)" [color]="shareType.buttonColor"
            [matMenuTriggerFor]="showShareMenu(shareType) ? menu : null" [matTooltip]="shareType.toolTip">
            <span class="wrapper">
              {{ shareType.text }}
              <mat-icon [svgIcon]="shareType.icon"> </mat-icon>
            </span>
          </button>
          <mat-progress-bar *ngIf="shareType.active && gettingProjectId" mode="indeterminate"></mat-progress-bar>
        </div>
        <mat-menu #menu="matMenu">
          @for (platform of sharePlatforms; track platform.name) {
          <button mat-menu-item
                  [shareButton]="platform.name" [url]="platform.link ? platform.link() : activeShareType?.link()"
                  [hidden]="activeShareType?.excludePlatforms?.includes(platform.name)">
            <mat-icon [svgIcon]="platform.icon" [ngStyle]="{'color': platform.iconColor}"> </mat-icon>
            {{ platform.description }}
          </button>
          }
        </mat-menu>
        }
      </div>
    </div>
  </div>

  <mbnm-promotion [shoppingCart]="currentCart" *ngIf="currentCart && currentCart.promotion"></mbnm-promotion>

  <mbnm-reviews [reviewCount]="6" starRating="5" filterBy="has_images" title="See what other customers are saying about us..."></mbnm-reviews>
</ng-container>
